<template>
	<div class="cd-not-available" >
		<ClientOnly>
			<BaseCmsLabel code="product_not_available_header" class="cd-not-available-header" tag="div" />
			<div class="cd-notifyme-form">
				<BaseFeedbackNotificationForm class="form-notifyme cd-form-notifyme form-animated-label" v-slot="{fields, status, loading}">
					<div class="cd-form-notifyme-cnt" v-if="!status?.success">
						<BaseFormField v-for="field in fields" :key="field.name" :item="field" v-slot="{errorMessage, floatingLabel}">
							<div class="field" v-if="field.type != 'hidden'" :class="{'ffl-floated': floatingLabel}">
								<BaseFormInput :id="`notification-${field.name}`" />
								<label :for="`notification-${field.name}`"><BaseCmsLabel code="enter_your_email" /></label>
								<span class="error" v-show="errorMessage" v-html="errorMessage" />
							</div>
							<BaseFormInput v-else :id="`notification-${field.name}`" :value="productId" />
						</BaseFormField>
						<button :disabled="loading" class="btn btn-green btn-notifyme-form" type="submit"><BaseCmsLabel code="notifyme" /></button>
					</div>
					<div class="notifyme-success" v-show="status?.success">
						<BaseCmsLabel code="notifyme_catalog_ty" class="notifyme-success-content" tag="div" />
					</div>
				</BaseFeedbackNotificationForm>
			</div>
		</ClientOnly>
	</div>
</template>

<script setup>
	const props = defineProps(['item', 'status']);
	const productId = computed(() => (props.item?.widget_code) ? props.item.widget_code.replace(/_/g, "-") : null);
</script>

<style lang="less" scoped>
	.cd-not-available{
		position: relative; display: flex; flex-flow: column; width: 100%; padding-top: 7px;
		@media (max-width: @tp){padding-top: 12px;}
		@media (max-width: @m){padding-top: 15px;}
	}
	:deep(.cd-not-available-header){
		display: block; margin-bottom: 12px; font-size: 18px; line-height: 22px;
		h2{color: var(--red); font-size: 30px; line-height: 36px; margin-bottom: 8px; padding: 0; font-weight: bold;}
		p:last-child{padding-bottom: 0;}
		@media (max-width: @t){
			font-size: 16px; line-height: 20px;
			h2{font-size: 28px; line-height: 32px;}
		}
		@media (max-width: @tp){
			font-size: 18px; line-height: 24px; margin-bottom: 12px;
			h2{font-size: 24px; line-height: 26px; margin-bottom: 8px;}
		}
	}
	:deep(.cd-form-notifyme-cnt){
		position: relative; display: flex; align-items: center; flex-wrap: wrap;
		input{padding-right: 130px;}
		.field{width: 100%;}
		@media (max-width: @tp){
			input{padding-right: 110px;}
			label{top: 16px;}
			.ffl-floated label{top: 5px;}
		}
		@media (max-width: @m){
			input{height: 50px;}
		}
	}
	.btn-notifyme-form{
		position: absolute; top: 4px; right: 4px; width: 114px; height: 51px; padding: 0; margin: 0; min-width: 110px;
		@media (max-width: @t){height: 42px;}
		@media (max-width: @tp){width: 92px; min-width: 92px; height: 44px; font-size: 16px; line-height: 44px; top: 3px;}
	}
	.notifyme-success{width: 100%;}
</style>